<template>
  <router-view />
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;600&display=swap");

html,
body,
#app {
  margin: 0;
  padding: 0;
  direction: rtl;
  text-align: right;
  font-family: Cairo;
  background: #f4f6f9;
  color: #071126;
  transition: all 0.3s ease;
}

* {
  box-sizing: border-box;
}

.num {
  font-family: "JetBrains Mono", monospace;
}

/* =========================
   DARK MODE
========================= */

html[data-theme="dark"],
body.dark-mode {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}

html[data-theme="dark"] #app {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}

/* الصفحات */

html[data-theme="dark"] .dashboard-page,
html[data-theme="dark"] .reports-page,
html[data-theme="dark"] .facilities-page,
html[data-theme="dark"] .facility-page,
html[data-theme="dark"] .priority-page,
html[data-theme="dark"] .infra-page,
html[data-theme="dark"] .map-page,
html[data-theme="dark"] .settings-page {
  background: #0f172a !important;
  color: #e2e8f0 !important;
}

/* البطاقات */

html[data-theme="dark"] .card,
html[data-theme="dark"] .report-card,
html[data-theme="dark"] .table-card,
html[data-theme="dark"] .axis-card,
html[data-theme="dark"] .map-card,
html[data-theme="dark"] .filter-card,
html[data-theme="dark"] .info-card,
html[data-theme="dark"] .stat-card,
html[data-theme="dark"] .kpi-card,
html[data-theme="dark"] .v-card {
  background: #1e293b !important;
  color: #e2e8f0 !important;
  border-color: #334155 !important;
}

/* النصوص */

html[data-theme="dark"] h1,
html[data-theme="dark"] h2,
html[data-theme="dark"] h3,
html[data-theme="dark"] h4,
html[data-theme="dark"] strong,
html[data-theme="dark"] .main-title {
  color: #f8fafc !important;
}

html[data-theme="dark"] p,
html[data-theme="dark"] span,
html[data-theme="dark"] small,
html[data-theme="dark"] .sub-title,
html[data-theme="dark"] .desc {
  color: #cbd5e1 !important;
}

/* الجداول */

html[data-theme="dark"] table {
  background: #1e293b !important;
}

html[data-theme="dark"] thead {
  background: #0f172a !important;
}

html[data-theme="dark"] td {
  background: #1e293b !important;
  color: #e2e8f0 !important;
  border-color: #334155 !important;
}

html[data-theme="dark"] tbody tr:hover {
  background: #273449 !important;
}

/* Inputs */

html[data-theme="dark"] input,
html[data-theme="dark"] select,
html[data-theme="dark"] textarea {
  background: #273449 !important;
  color: #fff !important;
  border: 1px solid #475569 !important;
}

/* Vuetify */

html[data-theme="dark"] .v-main {
  background: #0f172a !important;
}

html[data-theme="dark"] .v-navigation-drawer {
  background: #111827 !important;
}

html[data-theme="dark"] .v-list-item {
  color: #e2e8f0 !important;
}

html[data-theme="dark"] .v-field {
  background: #273449 !important;
  color: #fff !important;
}

/* Scrollbar */

html[data-theme="dark"] ::-webkit-scrollbar {
  width: 10px;
}

html[data-theme="dark"] ::-webkit-scrollbar-track {
  background: #0f172a;
}

html[data-theme="dark"] ::-webkit-scrollbar-thumb {
  background: #475569;
  border-radius: 8px;
}
html,
body,
#app,
.v-application {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
}
</style>
